<template>
    <div>
        <v-row class="mb-2 px-2 px-md-4">
            <v-col cols="12">
                <v-card class="pa-4" :color="'#FBFAF1'" outlined>
                    <div class="d-flex flex-column flex-md-row justify-space-between align-start align-md-center">
                        <div>
                            <div class="text-h6 font-weight-bold perfil-titulo">{{ $t('mensajes.central_reservas.perfil.titulo') }}</div>
                            <div class="text-body-2 grey--text text--darken-1 mt-1">
                                {{ $t('mensajes.central_reservas.perfil.descripcion') }}
                            </div>
                        </div>
                        <v-chip v-if="origen && origen.is_active" color="green lighten-4" text-color="green darken-3" class="mt-3 mt-md-0" small>
                            {{ $t('mensajes.central_reservas.perfil.agencia_activa') }}
                        </v-chip>
                        <div class="d-flex flex-column align-end mt-3 mt-md-0">
                            <div class="d-flex flex-wrap justify-end">
                                <v-btn
                                    outlined
                                    color="#191970"
                                    class="mr-2 mb-2 mb-md-0"
                                    :loading="refrescandoPerfil"
                                    :disabled="guardando || refrescandoPerfil || !access_token"
                                    @click="refrescarPerfilAgencia"
                                >
                                    <v-icon left small>mdi-refresh</v-icon>
                                    {{ $t('mensajes.central_reservas.perfil.refrescar') }}
                                </v-btn>
                                <v-btn
                                    color="#191970"
                                    dark
                                    class="mb-2 mb-md-0"
                                    :loading="guardando"
                                    :disabled="guardando || refrescandoPerfil || !origenId"
                                    @click="guardarPerfilAgencia"
                                >
                                    {{ $t('mensajes.central_reservas.perfil.guardar') }}
                                </v-btn>
                            </div>
                            <div v-if="!origenId" class="text-caption grey--text text--darken-1 mt-2">
                                {{ $t('mensajes.central_reservas.perfil.sin_agencia') }}
                            </div>
                        </div>
                    </div>
                    <v-alert v-if="mensajeExito" type="success" dense text class="mt-4 mb-0">
                        {{ mensajeExito }}
                    </v-alert>
                    <v-alert v-if="mostrarAvisoCompletarPerfil" type="error" dense text class="mt-4 mb-0">
                        {{ $t('mensajes.central_reservas.perfil.aviso_completar') }}
                    </v-alert>
                    <v-alert v-if="mensajeError" type="error" dense text class="mt-4 mb-0">
                        {{ mensajeError }}
                    </v-alert>
                </v-card>
            </v-col>
        </v-row>

        <v-row class="px-2 px-md-4">
            <v-col cols="12" lg="4">
                <v-card class="pa-4 fill-height" outlined :color="'#FBFAF1'">
                    <div class="d-flex flex-column align-center text-center">
                        <v-avatar
                            size="112"
                            color="white"
                            class="perfil-avatar mb-4"
                            :class="{ 'perfil-avatar--error': tieneErrorCampo('logo') }"
                        >
                            <v-img v-if="logoDataUrl" :src="logoDataUrl" contain />
                            <v-icon v-else color="#191970" size="56">mdi-office-building-outline</v-icon>
                        </v-avatar>

                        <input
                            ref="logoInput"
                            type="file"
                            accept="image/*"
                            class="d-none"
                            @change="onLogoSelected"
                        />
                        <v-btn
                            small
                            outlined
                            color="#191970"
                            class="mb-3"
                            :disabled="guardando"
                            @click="abrirSelectorLogo"
                        >
                            {{ $t('mensajes.central_reservas.perfil.cambiar_logo') }}
                        </v-btn>
                        <div v-if="logoSeleccionadoNombre" class="text-caption grey--text text--darken-1 mb-2">
                            {{ logoSeleccionadoNombre }}
                        </div>
                        <div v-if="tieneErrorCampo('logo')" class="text-caption error--text mb-2">
                            {{ $t('mensajes.central_reservas.perfil.campo_obligatorio') }}
                        </div>

                        <div class="text-h6 font-weight-bold">{{ getValor(form.nombre) }}</div>
                        <div class="text-body-2 grey--text text--darken-1 mt-1">
                            {{ getValor(form.identificador) }}
                        </div>

                        <v-chip class="mt-4" color="#191970" text-color="white" small>
                            {{ $t('mensajes.central_reservas.perfil.comision') }} {{ getValor(form.comision, true) }}
                        </v-chip>
                    </div>
                </v-card>
            </v-col>

            <v-col cols="12" lg="8">
                <v-card class="pa-4 mb-4" outlined :color="'#FBFAF1'">
                    <div class="text-subtitle-1 font-weight-bold mb-3">{{ $t('mensajes.central_reservas.perfil.datos_generales') }}</div>
                    <v-row dense>
                        <v-col cols="12">
                            <v-text-field v-model="form.nombre" :label="$t('mensajes.central_reservas.perfil.nombre')" outlined dense background-color="white" :error="tieneErrorCampo('nombre')" />
                        </v-col>
                      <!--  <v-col cols="12">
                            <v-text-field v-model="form.descripcion" label="Descripción" outlined dense background-color="white" :error="tieneErrorCampo('descripcion')" />
                        </v-col> -->
                        <v-col cols="12">
                            <v-text-field v-model="form.responsable" :label="$t('mensajes.central_reservas.perfil.responsable')" outlined dense background-color="white" :error="tieneErrorCampo('responsable')" />
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="form.telefono" :label="$t('mensajes.telefono')" outlined dense background-color="white" :error="tieneErrorCampo('telefono')" />
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="form.telefono_2" :label="$t('mensajes.central_reservas.perfil.telefono_2')" outlined dense background-color="white" />
                        </v-col>
                        <v-col cols="12">
                            <v-text-field v-model="form.email" label="Email" outlined dense background-color="white" :error="tieneErrorCampo('email')" />
                        </v-col>
                      <!--  <v-col cols="12">
                            <v-text-field :value="getValor(form.identificador)" label="Identificador" outlined dense background-color="white" readonly />
                        </v-col> -->
                        <v-col cols="12">
                            <v-text-field v-model="form.direccion" :label="$t('mensajes.central_reservas.perfil.direccion')" outlined dense background-color="white" :error="tieneErrorCampo('direccion')" />
                        </v-col>
                        <v-col cols="12">
                            <v-text-field v-model="form.cod_postal" :label="$t('mensajes.central_reservas.perfil.codigo_postal')" outlined dense background-color="white" :error="tieneErrorCampo('cod_postal')" />
                        </v-col>
                        <v-col cols="12">
                            <v-text-field v-model="form.poblacion" :label="$t('mensajes.central_reservas.perfil.poblacion')" outlined dense background-color="white" :error="tieneErrorCampo('poblacion')" />
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="form.provincia"
                                :label="$t('mensajes.central_reservas.perfil.provincia')"
                                outlined
                                dense
                                background-color="white"
                                :error="tieneErrorCampo('provincia')"
                            />  
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-select
                                v-model="form.pais"
                                :items="codigosPais"
                                item-text="name"
                                item-value="name"
                                :label="$t('mensajes.central_reservas.perfil.pais')"
                                outlined
                                dense
                                background-color="white"
                                :error="tieneErrorCampo('pais')"
                            />
                        </v-col>
                    </v-row>
                </v-card>

                <v-card class="pa-4" outlined :color="'#FBFAF1'">
                    <div class="text-subtitle-1 font-weight-bold mb-3">{{ $t('mensajes.central_reservas.perfil.datos_fiscales') }}</div>
                    <v-row dense>
                        <v-col cols="12">
                            <v-text-field v-model="form.nombre_fiscal" :label="$t('mensajes.central_reservas.perfil.nombre_fiscal')" outlined dense background-color="white" :error="tieneErrorCampo('nombre_fiscal')" />
                        </v-col>
                        <v-col cols="12">
                            <v-text-field v-model="form.cif" label="CIF" outlined dense background-color="white" :error="tieneErrorCampo('cif')" />
                        </v-col>
                        <v-col cols="12">
                            <v-text-field v-model="form.direccion_fiscal" :label="$t('mensajes.central_reservas.perfil.direccion_fiscal')" outlined dense background-color="white" :error="tieneErrorCampo('direccion_fiscal')" />
                        </v-col>
                        <v-col cols="12">
                            <v-text-field v-model="form.cod_postal_fiscal" :label="$t('mensajes.central_reservas.perfil.codigo_postal_fiscal')" outlined dense background-color="white" :error="tieneErrorCampo('cod_postal_fiscal')" />
                        </v-col>
                        <v-col cols="12">
                            <v-text-field v-model="form.poblacion_fiscal" :label="$t('mensajes.central_reservas.perfil.poblacion_fiscal')" outlined dense background-color="white" :error="tieneErrorCampo('poblacion_fiscal')" />
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="form.provincia_fiscal" :label="$t('mensajes.central_reservas.perfil.provincia_fiscal')" outlined dense background-color="white" :error="tieneErrorCampo('provincia_fiscal')" />
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-select
                                v-model="form.pais_fiscal"
                                :items="codigosPais"
                                item-text="name"
                                item-value="name"
                                :label="$t('mensajes.central_reservas.perfil.pais_fiscal')"
                                outlined
                                dense
                                background-color="white"
                                :error="tieneErrorCampo('pais_fiscal')"
                            />
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>

        <v-row class="px-2 px-md-4 mt-1">
            <v-col cols="12" xl="6">
                <v-card class="pa-4 fill-height" outlined :color="'#FBFAF1'">
                    <div class="text-subtitle-1 font-weight-bold mb-3">{{ $t('mensajes.central_reservas.perfil.usuarios_asociados') }}</div>
                    <v-data-table
                        dense
                        hide-default-footer
                        :headers="headersUsuariosTraducidos"
                        :items="usuarios"
                        class="elevation-0 bordered-table"
                    >
                        <template v-slot:[`item.nombre`]="{ item }">
                            <span>{{ getNombreUsuario(item) }}</span>
                        </template>
                        <template v-slot:[`item.email`]="{ item }">
                            <span>{{ getValor(item.email) }}</span>
                        </template>
                        <template v-slot:[`item.telefono`]="{ item }">
                            <span>{{ getValor(item.telefono) }}</span>
                        </template>
                        <template v-slot:[`item.username`]="{ item }">
                            <span>{{ getValor(item.username) }}</span>
                        </template>
                        <template v-slot:no-data>
                            {{ $t('mensajes.central_reservas.perfil.sin_usuarios') }}
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>

            <v-col cols="12" xl="6">
                <v-card class="pa-4 fill-height" outlined :color="'#FBFAF1'">
                    <div class="text-subtitle-1 font-weight-bold mb-3">{{ $t('mensajes.central_reservas.perfil.caminos_permitidos') }}</div>
                    <v-data-table
                        dense
                        hide-default-footer
                        :items-per-page="-1"
                        :headers="headersCaminosTraducidos"
                        :items="caminos"
                        class="elevation-0 bordered-table"
                    >
                        <template v-slot:[`item.titulo`]="{ item }">
                            <div>
                                <div class="font-weight-medium">{{ getValor(item.titulo) }}</div>
                                <div class="text-caption grey--text text--darken-1">{{ getValor(item.subtitulo) }}</div>
                            </div>
                        </template>
                        <template v-slot:[`item.codigo`]="{ item }">
                            <span>{{ getValor(item.codigo) }}</span>
                        </template>
                        <template v-slot:no-data>
                            {{ $t('mensajes.central_reservas.perfil.sin_caminos') }}
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapState } from 'vuex';
import { PERFIL_AGENCIA_CAMPOS_REQUERIDOS, campoPerfilAgenciaValido } from '../../config/perfilAgencia';

export default {
    name: 'PerfilAgenciaSection',
    data() {
        return {
            form: {
                nombre: '',
                nombre_fiscal: '',
                responsable: '',
                cif: '',
                codigo: '',
                identificador: '',
                descripcion: '',
                observacion: '',
                telefono: '',
                telefono_2: '',
                email: '',
                direccion: '',
                cod_postal: '',
                poblacion: '',
                provincia: '',
                pais: '',
                direccion_fiscal: '',
                cod_postal_fiscal: '',
                poblacion_fiscal: '',
                provincia_fiscal: '',
                pais_fiscal: '',
                comision: ''
            },
            headersUsuarios: [
                { text: 'NOMBRE', value: 'nombre', sortable: false },
                { text: 'USERNAME', value: 'username', sortable: false },
                { text: 'EMAIL', value: 'email', sortable: false },
                { text: 'TELÉFONO', value: 'telefono', sortable: false }
            ],
            headersCaminos: [
                { text: 'CÓDIGO', value: 'codigo', sortable: false, width: '140px' },
                { text: 'CAMINO', value: 'titulo', sortable: false }
            ],
            guardando: false,
            refrescandoPerfil: false,
            mensajeExito: '',
            mensajeError: '',
            logoBase64: '',
            logoMimeType: '',
            logoSeleccionadoNombre: '',
            logoPreviewDataUrl: ''
        };
    },
    computed: {
        ...mapGetters('paises', ['getCodigosPais', 'getProvinciasEspana']),
        ...mapState('auth', ['user', 'access_token']),
        headersUsuariosTraducidos() {
            const t = this.$t.bind(this);
            return [
                { text: t('mensajes.central_reservas.perfil.nombre'), value: 'nombre', sortable: false },
                { text: 'Username', value: 'username', sortable: false },
                { text: 'Email', value: 'email', sortable: false },
                { text: t('mensajes.telefono'), value: 'telefono', sortable: false }
            ];
        },
        headersCaminosTraducidos() {
            const t = this.$t.bind(this);
            return [
                { text: t('mensajes.central_reservas.expedientes.codigo'), value: 'codigo', sortable: false, width: '140px' },
                { text: t('mensajes.central_reservas.perfil.camino'), value: 'titulo', sortable: false }
            ];
        },
        origen() {
            return this.user && this.user.origen ? this.user.origen : null;
        },
        origenId() {
            if (!this.origen) return null;
            if (this.origen.id !== null && this.origen.id !== undefined && this.origen.id !== '') {
                return this.origen.id;
            }
            if (this.origen.identificador !== null && this.origen.identificador !== undefined && this.origen.identificador !== '') {
                return this.origen.identificador;
            }
            return null;
        },
        codigosPais() {
            return this.getCodigosPais;
        },
        provinciasEspana() {
            return this.getProvinciasEspana;
        },
        usuarios() {
            return this.origen && Array.isArray(this.origen.users) ? this.origen.users : [];
        },
        caminos() {
            return this.origen && Array.isArray(this.origen.caminos) ? this.origen.caminos : [];
        },
        logoDataUrl() {
            if (this.logoPreviewDataUrl) return this.logoPreviewDataUrl;
            if (!this.origen || !this.origen.logo) return '';
            return `data:image/png;base64,${this.origen.logo}`;
        },
        mostrarAvisoCompletarPerfil() {
            return this.$route && this.$route.query && this.$route.query.aviso_perfil_incompleto === '1';
        },
        camposRequeridos() {
            return PERFIL_AGENCIA_CAMPOS_REQUERIDOS;
        }
    },
    watch: {
        origen: {
            immediate: true,
            handler(origen) {
                this.logoBase64 = '';
                this.logoMimeType = '';
                this.logoSeleccionadoNombre = '';
                this.logoPreviewDataUrl = '';
                this.form = {
                    nombre: origen && origen.nombre ? origen.nombre : '',
                    nombre_fiscal: origen && origen.nombre_fiscal ? origen.nombre_fiscal : '',
                    responsable: origen && origen.responsable ? origen.responsable : '',
                    cif: origen && origen.cif ? origen.cif : '',
                    codigo: origen && origen.codigo ? origen.codigo : '',
                    identificador: origen && origen.identificador ? origen.identificador : '',
                    descripcion: origen && origen.descripcion ? origen.descripcion : '',
                    observacion: origen && origen.observacion ? origen.observacion : '',
                    telefono: origen && origen.telefono ? origen.telefono : '',
                    telefono_2: origen && origen.telefono_2 ? origen.telefono_2 : '',
                    email: origen && origen.email ? origen.email : '',
                    direccion: origen && origen.direccion ? origen.direccion : '',
                    cod_postal: origen && origen.cod_postal ? origen.cod_postal : '',
                    poblacion: origen && origen.poblacion ? origen.poblacion : '',
                    provincia: origen && origen.provincia ? origen.provincia : '',
                    pais: origen && origen.pais ? origen.pais : '',
                    direccion_fiscal: origen && origen.direccion_fiscal ? origen.direccion_fiscal : '',
                    cod_postal_fiscal: origen && origen.cod_postal_fiscal ? origen.cod_postal_fiscal : '',
                    poblacion_fiscal: origen && origen.poblacion_fiscal ? origen.poblacion_fiscal : '',
                    provincia_fiscal: origen && origen.provincia_fiscal ? origen.provincia_fiscal : '',
                    pais_fiscal: origen && origen.pais_fiscal ? origen.pais_fiscal : '',
                    comision: origen && origen.comision !== null && origen.comision !== undefined ? origen.comision : ''
                };
            }
        }
    },
    methods: {
        buildPayload() {
            const camposEditables = [
                'nombre',
                'nombre_fiscal',
                'responsable',
                'cif',
                'descripcion',
                'telefono',
                'telefono_2',
                'email',
                'direccion',
                'cod_postal',
                'poblacion',
                'provincia',
                'pais',
                'direccion_fiscal',
                'cod_postal_fiscal',
                'poblacion_fiscal',
                'provincia_fiscal',
                'pais_fiscal'
            ];

            return camposEditables.reduce((payload, campo) => {
                payload[campo] = this.form[campo];
                return payload;
            }, this.logoBase64 ? { logo: this.logoBase64 } : {});
        },
        extraerOrigenActualizado(response) {
            if (!response || !response.data) return null;

            if (response.data.origen) return response.data.origen;
            if (response.data.data && response.data.data.origen) return response.data.data.origen;
            if (response.data.data) return response.data.data;

            return response.data;
        },
        extraerUsuarioAutenticado(response) {
            if (!response || !response.data) return null;

            if (response.data.user) return response.data.user;
            if (response.data.data && response.data.data.user) return response.data.data.user;
            if (response.data.data) return response.data.data;

            return response.data;
        },
        async refrescarPerfilAgencia() {
            if (!this.access_token || this.refrescandoPerfil || this.guardando) return;

            this.refrescandoPerfil = true;
            this.mensajeExito = '';
            this.mensajeError = '';

            try {
                const response = await Vue.axios({
                    method: 'GET',
                    url: '/me',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': 'Bearer ' + this.access_token
                    }
                });

                const userActualizado = this.extraerUsuarioAutenticado(response);
                if (!userActualizado) {
                    throw new Error('missing-user');
                }

                this.$store.commit('auth/setUser', userActualizado);
            } catch (e) {
                this.mensajeError = this.$t('mensajes.central_reservas.perfil.error_refrescar');
            } finally {
                this.refrescandoPerfil = false;
            }
        },
        async guardarPerfilAgencia() {
            if (!this.origenId || this.guardando) return;

            this.guardando = true;
            this.mensajeExito = '';
            this.mensajeError = '';
            const payload = this.buildPayload();

            try {
                const response = await Vue.axios({
                    method: 'PATCH',
                    url: `/origenes/${this.origenId}`,
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': 'Bearer ' + this.access_token
                    },
                    data: payload
                });

                const origenActualizado = this.extraerOrigenActualizado(response);
                const origenNuevo = origenActualizado
                    ? { ...(this.origen || {}), ...origenActualizado }
                    : { ...(this.origen || {}), ...payload };

                this.$store.commit('auth/setUser', {
                    ...(this.user || {}),
                    origen: origenNuevo
                });

                this.mensajeExito = this.$t('mensajes.central_reservas.perfil.exito_guardar');
            } catch (e) {
                this.mensajeError = this.$t('mensajes.central_reservas.perfil.error_guardar');
            } finally {
                this.guardando = false;
            }
        },
        abrirSelectorLogo() {
            if (this.$refs.logoInput) {
                this.$refs.logoInput.click();
            }
        },
        async onLogoSelected(event) {
            const file = event && event.target && event.target.files ? event.target.files[0] : null;
            if (!file) return;

            if (!file.type || !file.type.startsWith('image/')) {
                this.mensajeError = this.$t('mensajes.central_reservas.perfil.error_imagen_invalida');
                event.target.value = '';
                return;
            }

            try {
                const resized = await this.resizeImageToMaxHeight(file, 200);
                this.logoBase64 = resized.base64;
                this.logoMimeType = resized.mimeType;
                this.logoPreviewDataUrl = resized.dataUrl;
                this.logoSeleccionadoNombre = file.name;
                this.mensajeError = '';
                this.mensajeExito = '';
            } catch (error) {
                this.mensajeError = this.$t('mensajes.central_reservas.perfil.error_procesar_imagen');
            } finally {
                event.target.value = '';
            }
        },
        resizeImageToMaxHeight(file, maxHeight) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();

                reader.onerror = () => reject(new Error('read-error'));
                reader.onload = () => {
                    const image = new Image();

                    image.onerror = () => reject(new Error('image-error'));
                    image.onload = () => {
                        const originalWidth = image.naturalWidth || image.width;
                        const originalHeight = image.naturalHeight || image.height;
                        if (!originalWidth || !originalHeight) {
                            reject(new Error('invalid-dimensions'));
                            return;
                        }

                        const targetHeight = Math.min(maxHeight, originalHeight);
                        const scale = targetHeight / originalHeight;
                        const targetWidth = Math.round(originalWidth * scale);

                        const canvas = document.createElement('canvas');
                        canvas.width = targetWidth;
                        canvas.height = targetHeight;

                        const ctx = canvas.getContext('2d');
                        if (!ctx) {
                            reject(new Error('no-context'));
                            return;
                        }

                        ctx.drawImage(image, 0, 0, targetWidth, targetHeight);

                        const mimeType = file.type === 'image/png' ? 'image/png' : 'image/jpeg';
                        const dataUrl = canvas.toDataURL(mimeType, 0.9);
                        const base64 = dataUrl.split(',')[1] || '';

                        resolve({
                            mimeType,
                            dataUrl,
                            base64
                        });
                    };

                    image.src = reader.result;
                };

                reader.readAsDataURL(file);
            });
        },
        getValor(valor, esPorcentaje = false) {
            if (valor === null || valor === undefined || valor === '') return '-';
            return esPorcentaje ? `${valor}%` : valor;
        },
        getNombreUsuario(item) {
            if (!item) return '-';
            return item.nombre || item.username || '-';
        },
        tieneErrorCampo(campo) {
            if (!this.origen || this.camposRequeridos.indexOf(campo) === -1) return false;

            if (campo === 'logo') {
                return !campoPerfilAgenciaValido(this.logoBase64 || (this.origen && this.origen.logo));
            }

            return !campoPerfilAgenciaValido(this.form[campo]);
        }
    }
};
</script>

<style scoped>
.perfil-titulo {
    color: #191970;
}

.perfil-avatar {
    border: 1px solid rgba(25, 25, 112, 0.12);
}

.perfil-avatar--error {
    border-color: #ff5252;
}

.bordered-table ::v-deep td,
.bordered-table ::v-deep th {
    border-bottom: 1px solid #e5e7eb;
}
</style>
